import { render, staticRenderFns } from "./BusinessDialog.vue?vue&type=template&id=d58d84a8&scoped=true"
import script from "./BusinessDialog.vue?vue&type=script&lang=js"
export * from "./BusinessDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58d84a8",
  null
  
)

export default component.exports